import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const AlertsFeed = ({ alerts }) => {
  const [filter, setFilter] = useState('all');

  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'critical':
        return {
          color: 'text-error',
          bgColor: 'bg-error/10',
          icon: 'AlertCircle',
          label: 'Critical'
        };
      case 'warning':
        return {
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          icon: 'AlertTriangle',
          label: 'Warning'
        };
      case 'info':
        return {
          color: 'text-primary',
          bgColor: 'bg-primary/10',
          icon: 'Info',
          label: 'Info'
        };
      case 'success':
        return {
          color: 'text-success',
          bgColor: 'bg-success/10',
          icon: 'CheckCircle',
          label: 'Success'
        };
      default:
        return {
          color: 'text-muted-foreground',
          bgColor: 'bg-muted/10',
          icon: 'Bell',
          label: 'Notice'
        };
    }
  };

  const filteredAlerts = filter === 'all' 
    ? alerts 
    : alerts?.filter(alert => alert?.severity === filter);

  const filterOptions = [
    { value: 'all', label: 'All', count: alerts?.length },
    { value: 'critical', label: 'Critical', count: alerts?.filter(a => a?.severity === 'critical')?.length },
    { value: 'warning', label: 'Warning', count: alerts?.filter(a => a?.severity === 'warning')?.length },
    { value: 'info', label: 'Info', count: alerts?.filter(a => a?.severity === 'info')?.length }
  ];

  return (
    <div className="card h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Bell" size={20} className="text-foreground" />
          <h3 className="text-lg font-semibold text-foreground">System Alerts</h3>
        </div>
        <span className="caption text-muted-foreground">Live</span>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {filterOptions?.map((option) => (
          <button
            key={option?.value}
            onClick={() => setFilter(option?.value)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-smooth ${
              filter === option?.value
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted/30 text-muted-foreground hover:bg-muted/50'
            }`}
          >
            {option?.label} ({option?.count})
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-thin space-y-3">
        {filteredAlerts?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12">
            <Icon name="CheckCircle" size={48} className="text-success mb-3" />
            <p className="text-sm text-muted-foreground">No alerts in this category</p>
          </div>
        ) : (
          filteredAlerts?.map((alert) => {
            const config = getSeverityConfig(alert?.severity);
            return (
              <div
                key={alert?.id}
                className={`p-4 rounded-lg border border-border ${config?.bgColor} hover:shadow-md transition-smooth cursor-pointer`}
              >
                <div className="flex items-start gap-3">
                  <Icon name={config?.icon} size={20} className={config?.color} />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className={`text-xs font-semibold ${config?.color} uppercase`}>
                        {config?.label}
                      </span>
                      <span className="caption text-muted-foreground">{alert?.timestamp}</span>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground mb-1">{alert?.title}</h4>
                    <p className="text-sm text-muted-foreground line-clamp-2">{alert?.message}</p>
                    {alert?.action && (
                      <button className="mt-2 text-sm font-medium text-primary hover:underline">
                        {alert?.action}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default AlertsFeed;